import { render, staticRenderFns } from "./info-form.vue?vue&type=template&id=5ef221fe&scoped=true&"
import script from "./info-form.vue?vue&type=script&lang=js&"
export * from "./info-form.vue?vue&type=script&lang=js&"
import style0 from "./info-form.vue?vue&type=style&index=0&id=5ef221fe&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef221fe",
  null
  
)

export default component.exports